import { makeUseAxios } from "axios-hooks";
import axios from "./axios";

/**
 * Deprecated -> migrate to tanstack/react-query
 */
export default makeUseAxios({
  cache: false,
  axios,
});
